/**
 * @file: maskedMobilePhone.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export const maskedMobilePhone = (s: string | null | undefined) => {
  if (!s) return '';
  return s.substring(0, 3) + '****' + s.substring(s.length - 4);
};
